import { CheckboxFilledIcon, CheckboxIcon } from "@/components/icons";
import { cn } from "@/utils/utils";
import { ReactNode } from "react";


export default function ProductFilterItem({
  children,
  active,
}: {
  children: ReactNode
  active: boolean;
}) {


  return (
    <>
      <div
        className="flex items-center text-sm pb-[5px] pr-[18px] group"
      >
        <span className={cn("text-sm hidden group-hover:block ", {
          "block": active
        })} >
          <CheckboxFilledIcon />
        </span>
        <span className={cn("text-sm group-hover:hidden", {
          "hidden": active
        })}>
          <CheckboxIcon />
        </span>
        {
          children
        }
      </div>
    </>
  );
};